var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCCNSW)?_c('forgot-user-data-page-ccnsw'):(_vm.isStatewide)?_c('forgot-user-data-page-stw'):_c('forgot-user-data-page-default')
}
var staticRenderFns = []

export { render, staticRenderFns }